import angular from 'angular';
import uiRouter from 'angular-ui-router';
import footerComponent from './footer.component';

let footerModule = angular.module('footer', [
  uiRouter
])

.component('footer', footerComponent)

.name;

export default footerModule;



// WEBPACK FOOTER //
// ./client/app/common/footer/footer.js